
// const AntVideoLauncher = require('./ant-video-parent');
// const AntVideoChild = require('./ant-video-child');
import AntVideoChild from './ant-video-child';
import AntVideoLauncher from './ant-video-parent';

export {
    AntVideoLauncher,
    AntVideoChild,    
};

// export default AntVideoChild;
